import React from 'react'
import styles from './consultantCardProfile.module.scss'
import I18n from 'i18n-js'
import { useSelector, useDispatch } from 'react-redux'
import { ReactComponent as ArrowLeft } from '../../../../assets/svgs/arrow_left.svg'
import { ReactComponent as TimeZone } from '../../../../assets/svgs/time_zone.svg'
import { ReactComponent as FaLanguage } from '../../../../assets/svgs/farsi_language.svg'
import { ReactComponent as RialCoin } from '../../../../assets/svgs/rial_coin.svg'
import { ReactComponent as DollarCoin } from '../../../../assets/svgs/dollar_coin.svg'
import { ReactComponent as EnLanguage } from '../../../../assets/svgs/english_language.svg'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import jMoment from 'moment-jalaali'
import * as FormAction from './../../FormAction'
import Icon from './../../../../assets/images/icon.png'

const useStyles = makeStyles((theme) => ({

	root: {
		paddingBottom: 8
	},

	info: {
		[theme.breakpoints.up('md')]: {
			borderRight: '1px solid #E6E8F2',
			paddingRight: '12px'
		}
	},

	infoService: {

		padding: 6,

		[theme.breakpoints.up('md')]: {
			'body[dir=rtl] &': {
				borderRight: '1px solid #E6E8F2',
				paddingRight: '12px'
			},
			'body[dir=ltr] &': {
				borderLeft: '1px solid #E6E8F2',
				paddingLeft: '12px'
			}

		},
		'& span': {
			fontSize: '14px',
			margin: 0,
			color: '#18191F'
		},
		'& h5': {
			margin: 0,
			fontSize: '12px',
			color: '#7A819B'

		}
	},
	infoTime: {
		padding: 6,
		'& span': {
			fontSize: '14px',
			margin: 0,
			color: '#18191F'
		},
		'& h5': {
			margin: 0,
			fontSize: '12px',
			color: '#7A819B'

		}

	}
}))

const ConsultantCardProfile = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()

	const {
		first_name,
		last_name

	} = useSelector(state => state.ConsultantReducer)
	const {
		language,
		currency,
		timezone
	} = useSelector(state => state.SettingsReducer)

	const {
		service_id,
		date,
		time,
		endAt
	} = useSelector(state => state.FormReducer)

	const { services } = useSelector(state => state.ConsultantReducer)

	const goBack = () => {
		if (time) {
			dispatch(FormAction.goBackHandler('time'))
			return
		}

		if (service_id) {
			dispatch(FormAction.goBackHandler('service_id'))
			dispatch(FormAction.goBackHandler('date'))
			dispatch(FormAction.goBackHandler('calendarDate'))
			dispatch(FormAction.goBackHandler('time'))
			return
		}

		return props.history.goBack()
	}

	const getServiceName = () => {
		const service = services.filter(service => {
			return service.id === service_id
		})

		if (!service || !service.length) {
			return ''
		}

		return service[0].title
	}

	const getDay = () => {
		jMoment.loadPersian({ dialect: 'persian-modern' })

		const finalDate = jMoment(`${date} ${time}:00`, 'YYYY-MM-DD H:m:s').format('jD jMMMM jYYYY')

		return `${finalDate}`
	}
	const getEnDay = () => {

		const finalDate = jMoment(`${date} ${time}:00`, 'YYYY-MM-DD H:m:s').format('D MMMM YYYY')

		return `${finalDate}`
	}

	const getTime = () => {
		jMoment.loadPersian({ dialect: 'persian-modern' })

		const finalStartAt = jMoment(`${date} ${time}:00`, 'YYYY-MM-DD H:m:s').format('HH:mm')
		const finalEndAt = jMoment(`${date} ${endAt}:00`, 'YYYY-MM-DD H:m:s').format('HH:mm')

		const kind = jMoment(`${date} ${time}:00`, 'YYYY-MM-DD H:i:s').format('HH') >= 12
			? I18n.t('consultant.pm')
			: I18n.t('consultant.am')
		const timezoneT = I18n.t('settings.time')

		return ` ${finalStartAt} - ${finalEndAt} ${kind} ( ${timezoneT} ${timezone} )`
	}

	const getEnTime = () => {
		const finalStartAt = jMoment(`${date} ${time}:00`, 'YYYY-MM-DD H:m:s').format('HH:mm')
		const finalEndAt = jMoment(`${date} ${endAt}:00`, 'YYYY-MM-DD H:m:s').format('HH:mm')

		const kind = jMoment(`${date} ${time}:00`, 'YYYY-MM-DD H:i:s').format('HH') >= 12
			? I18n.t('consultant.pm')
			: I18n.t('consultant.am')
		const timezoneT = I18n.t('settings.time')

		return ` ${finalStartAt} - ${finalEndAt} ${kind} ( ${timezone} ${timezoneT} )`
	}

	const icons = {
		Dollar: <DollarCoin with={24} height={24} onClick={props.openCurrencyModal}/>,
		Rial: <RialCoin with={24} height={24} onClick={props.openCurrencyModal}/>,
		fa: <FaLanguage with={24} height={24} onClick={props.openLanguageModal}/>,
		en: <EnLanguage with={24} height={24} onClick={props.openLanguageModal}/>

	}

	return (
		<Grid container className={styles.Card}>
			<Grid container className={classes.root} dir={'rtl'}>
				<Grid item xs={6} md={6} className={styles.Icons}>
					<div>
						{icons[language]}
					</div>
					<div className={styles.icon}>
						{icons[currency] ? icons[currency] : icons['Dollar']}
					</div>
					<div className={styles.timezone} dir={'ltr'} onClick={props.openTimezoneModal}>
						<h5>{timezone}</h5>
						<TimeZone with={24} height={24}/>
					</div>
				</Grid>
				{first_name && <Grid item xs={6} md={6}>
					<div className={styles.ArrowLeft} onClick={goBack}>
						<ArrowLeft with={36} height={36}/>
					</div>
				</Grid>}
			</Grid>
			{first_name && <Grid container className={styles.borderTop}>
				<Grid xs={12} md={6}>
					<div className={classes.infoTime}>
						<h5>{I18n.t('consultant.profile.consultant')}<span>{first_name} {last_name}</span></h5>
					</div>
				</Grid>
				{service_id && <Grid xs={12} md={6} className={styles.info}>
					<div className={classes.infoService}>
						<h5>{I18n.t('consultant.profile.service')}<span>{getServiceName()}</span></h5>
					</div>
				</Grid>}
			</Grid>}
			{first_name && <Grid container>
				{date && <Grid xs={12} md={6}>
					<div className={classes.infoTime}>
						<h5>{I18n.t('consultant.profile.dateOfConsultation')}
							<span>{language === 'fa' ? getDay() : getEnDay()}</span>
						</h5>
					</div>
				</Grid>}
				{time && <Grid xs={12} md={6}>
					<div className={classes.infoService}>
						<h5>{I18n.t('consultant.profile.consultationHours')}
							<span>{language === 'fa' ? getTime() : getEnTime()}</span>
						</h5>
					</div>
				</Grid>}
			</Grid>}

		</Grid>

	)
}

export default ConsultantCardProfile
